/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

// @mui material components
import "rc-tree/assets/index.css";
import TextField from "@mui/material/TextField";
import MDTypography from "components/MDTypography";
import InputFileUpload from "./InputFile";
import moment from "moment";

function FormCargarDocumento({ props, onChangeGaleria }) {
  const { galeriaNombre, fechaFoto, archivo, descripcion } = props;

  return (
    <>
      <TextField
        value={galeriaNombre}
        onChange={(event) => {
          onChangeGaleria(event.target.value, "galeriaNombre");
        }}
        error={false}
        helperText={""}
        label={"Titulo"}
        onBlur={() => {}}
        style={{ width: "100%", marginBottom: "1.5rem", cursor: "pointer" }}
        variant="outlined"
        fullWidth
        size="small"
        autoComplete="off"
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        value={fechaFoto}
        onChange={(event) => {
          onChangeGaleria(event.target.value, "fechaFoto");
        }}
        error={false}
        helperText={""}
        label="Fecha"
        onBlur={() => {}}
        variant="outlined"
        onKeyDown={(e) => e.preventDefault()}
        onPaste={(e) => e.preventDefault()}
        style={{ width: "100%", marginBottom: "1.5rem", cursor: "pointer" }}
        size="small"
        type="date"
        autoComplete="off"
        inputProps={{
          max: moment().format("YYYY-MM-DD"),
        }}
        onClick={(e) => e.target.showPicker && e.target.showPicker()}
        InputLabelProps={{ shrink: true }}
      />
      <MDTypography variant="h5" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
        Archivo
      </MDTypography>
      <InputFileUpload
        onchangeFile={(archivo) => {
          onChangeGaleria(archivo, "archivo");
        }}
        valueF={archivo}
      />
      <TextField
        value={descripcion}
        onChange={(event) => {
          onChangeGaleria(event.target.value, "descripcion");
        }}
        label={"Descripcion"}
        variant="outlined"
        style={{ width: "100%", marginBottom: "1.5rem", marginTop: "1.5rem" }}
        multiline
        rows={4}
        size="small"
        autoComplete="off"
        InputLabelProps={{ shrink: true }}
      />
    </>
  );
}

export default FormCargarDocumento;
